import axios from 'axios';
import Cookies from 'js-cookie';
import { API } from '../../config/api';

export const FETCH_CONVERSATION_MESSAGE_REQUEST = 'FETCH_CONVERSATION_MESSAGE_REQUEST';
export const FETCH_CONVERSATION_MESSAGE_SUCCESS = 'FETCH_CONVERSATION_MESSAGE_SUCCESS';
export const FETCH_CONVERSATION_MESSAGE_FAILED = 'FETCH_CONVERSATION_MESSAGE_FAILED';
export const UPDATE_CONVERSATION_MESSAGE = 'UPDATE_CONVERSATION_MESSAGE';

// 🆕 New constants for single message
export const FETCH_SINGLE_MESSAGE_REQUEST = 'FETCH_SINGLE_MESSAGE_REQUEST';
export const FETCH_SINGLE_MESSAGE_SUCCESS = 'FETCH_SINGLE_MESSAGE_SUCCESS';
export const FETCH_SINGLE_MESSAGE_FAILED = 'FETCH_SINGLE_MESSAGE_FAILED';
export const APPEND_MESSAGE_TO_CONVERSATION = 'APPEND_MESSAGE_TO_CONVERSATION';

export const fetchConversationMessageRequest = () => ({
  type: FETCH_CONVERSATION_MESSAGE_REQUEST,
});

export const fetchConversationMessageSuccess = (messages) => ({
  type: FETCH_CONVERSATION_MESSAGE_SUCCESS,
  payload: messages,
});

export const fetchConversationMessageFailed = (error) => ({
  type: FETCH_CONVERSATION_MESSAGE_FAILED,
  payload: error,
});

export const updateConversationMessages = (updatedConversation) => ({
  type: UPDATE_CONVERSATION_MESSAGE,
  payload: updatedConversation,
});

export const appendMessageToConversation = (conversationId, message) => {
  // console.log('🟢 APPEND_MESSAGE called with payload:', message);
  return {
    type: APPEND_MESSAGE_TO_CONVERSATION,
    payload: { conversationId, message },
  };
};

// 🆕 Actions for single message
export const fetchSingleMessageRequest = () => ({
  type: FETCH_SINGLE_MESSAGE_REQUEST,
});

export const fetchSingleMessageSuccess = (message) => ({
  type: FETCH_SINGLE_MESSAGE_SUCCESS,
  payload: message,
});

export const fetchSingleMessageFailed = (error) => ({
  type: FETCH_SINGLE_MESSAGE_FAILED,
  payload: error,
});

// ✅ Fetch all messages
export const fetchMessages = () => {
  return async (dispatch) => {
    dispatch(fetchConversationMessageRequest());
    try {
      const response = await axios.get(`${API.messages}`);
      dispatch(fetchConversationMessageSuccess(response.data.conversations));
    } catch (error) {
      dispatch(fetchConversationMessageFailed(error.message));
    }
  };
};

// ✅ Fetch single message by ID
export const fetchMessageById = (conversationId, appId) => {
  const token = Cookies.get('token');
  return async (dispatch) => {
    dispatch(fetchSingleMessageRequest());
    try {
      const response = await axios.get(`${API.messages}/${conversationId}?app_id=${appId}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch(fetchSingleMessageSuccess(response.data));
    } catch (error) {
      dispatch(fetchSingleMessageFailed(`${error.response.data.message || 'Failed to load details.'}`));
    }
  };
};
